import MenuIcon from "@mui/icons-material/Menu";
import classNames from "classnames";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../../assets/logos/Myloc-logga.svg";
import pages from "../../../../utils/pages";
import MessageButton from "../../../Message/MessageButton";
import MenuDrawer, { MOBILE_MENU_DRAWER_ID } from "../../MobileMenu/MenuDrawer/MenuDrawer";
import CartButton from "../CartButton/CartButton";
import OrderMenu from "../OrderMenu/OrderMenu";
import ReceiverMenu from "../ReceiverMenu/ReceiverMenu";
import styles from "./MobileHeader.module.scss";

function MobileHeader() {
  const userLoggedIn = useSelector(state => state.session?.sessionId);
  const order = useSelector(state => state.appData.order);

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className={classNames(styles.header)}>
        <section className={styles.topBar}>
          <figure>
            <Link to={pages.HOME}>
              <img src={logo} alt="Myloc logo" className={styles.logo} />
            </Link>
          </figure>
          {userLoggedIn && (
            <div className={styles.topBarActions}>
              <MessageButton />
              <button
                type="button"
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
                aria-controls={MOBILE_MENU_DRAWER_ID}
                className={styles.menuButton}
                onClick={() => setMenuOpen(prev => !prev)}
              >
                <MenuIcon />
              </button>
            </div>
          )}
        </section>
        {userLoggedIn && (
          <section className={styles.actionBar}>
            {order?.receiver ? (
              <>
                <div className={styles.orderSection}>
                  <OrderMenu customCssClass={styles.orderMenu} />
                  <CartButton />
                </div>
                <ReceiverMenu customCssClass={styles.receiverMenu} />
              </>
            ) : (
              <OrderMenu customCssClass={styles.orderMenu} />
            )}
          </section>
        )}
      </header>
      {userLoggedIn && <MenuDrawer visible={menuOpen} onMenuLinkClick={() => setMenuOpen(false)} />}
    </>
  );
}

export default MobileHeader;
